import { initializeApp } from "firebase/app";
import {
  isSupported,
  getMessaging,
  getToken,
  deleteToken,
  onMessage,
} from "firebase/messaging";
import { getAnalytics, getGoogleAnalyticsClientId } from "firebase/analytics";
import { getRemoteConfig } from "firebase/remote-config";
import { hasConsent } from "./Utils/cookieConsent";

const firebaseConfig = {
  apiKey: "AIzaSyAb4fwNxFSLl82AqxgXHmCTdMUF5akBg0E",
  authDomain: "pajakind-43b0b.firebaseapp.com",
  databaseURL: "https://pajakind-43b0b.firebaseio.com",
  projectId: "pajakind-43b0b",
  storageBucket: "pajakind-43b0b.appspot.com",
  messagingSenderId: "791413447709",
  appId: "1:791413447709:web:ee942af7fb429ab6eb7af4",
  measurementId: "G-HFQENZF935",
};

const app = initializeApp(firebaseConfig);

export const analytics = getAnalytics(app);

// Resolves to null after `ms` so analytics can never hold up checkout.
const withTimeout = (promise, ms = 1000) =>
  Promise.race([
    promise,
    new Promise((resolve) => setTimeout(() => resolve(null), ms)),
  ]);

// GA4 identifiers sent with /pay. The backend uses them to report the
// purchase server-side once payment succeeds, so it is attributed to the ad
// click even if the buyer never comes back to the transaction page.
// Without analytics consent nothing is sent: the client id would only be a
// cookieless placeholder, and a server-side hit would track the visitor anyway.
export const getAnalyticsIds = async () => {
  if (!hasConsent("analytics")) return null;
  try {
    const clientId = await withTimeout(getGoogleAnalyticsClientId(analytics));
    if (!clientId) return null;

    const sessionId = await withTimeout(
      new Promise((resolve) => {
        if (typeof window.gtag !== "function") {
          resolve(null);
          return;
        }
        window.gtag("get", firebaseConfig.measurementId, "session_id", resolve);
      }),
    );

    const ids = { platform: "web", clientId };
    if (sessionId) {
      ids.sessionId = String(sessionId);
    }
    return ids;
  } catch (error) {
    return null;
  }
};

export const remoteConfig = getRemoteConfig(app);

const messaging = (async () => {
  try {
    const isSupportedBrowser = await isSupported();
    if (isSupportedBrowser) {
      return getMessaging(app);
    }
    return null;
  } catch (err) {
    return null;
  }
})();

export const getFirebaseToken = () => {
  return new Promise((resolve, reject) => {
    messaging
      .then((messaging) => {
        getToken(messaging, {
          vapidKey:
            "BIQpV2Knxhq5pEKgcN8t5OUgAuJ-RM_zZRdmFtCIoQnjVphOJ7r8X9fBkjMY9SFgzOLu0K3b77c2YHeBAlXDNEc",
        })
          .then((token) => {
            resolve(token);
          })
          .catch((error) => {
            reject(error);
          });
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// The FCM token is device-bound, so leaving it registered at logout means the
// next person to use this browser can keep receiving the previous user's
// notifications. Called on the way out of every logout path.
export const deleteFirebaseToken = async () => {
  try {
    const msg = await messaging;
    if (!msg) return false;
    return await deleteToken(msg);
  } catch (error) {
    return false;
  }
};

// Subscription-based listener. Returns an unsubscribe function, so callers can
// own the subscription from a useEffect instead of registering a fresh handler
// on every render.
export const subscribeToMessages = (callback) => {
  let unsubscribe = null;
  let cancelled = false;

  messaging
    .then((msg) => {
      // The caller may already have unsubscribed while this promise was still
      // pending — registering now would leak a handler nobody can remove.
      if (!msg || cancelled) return;
      unsubscribe = onMessage(msg, callback);
    })
    .catch(() => {});

  return () => {
    cancelled = true;
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = null;
    }
  };
};
